import React from "react";
// import { Button } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
import { addUserModal } from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import { history } from "../../app/AppRouter";
import { voiceReviewActionLabel } from "../voiceAdd/saveDraftEdit";

export const StepButton = (props) => {
  //console.log("stepButton", props);

  return (
    <>
      <div className="bg-white card-panel ex-space-y pt-0">
        <div className="action-wrapper blk-padding-y">
          <div className="action-inner-block">
            <div className="action-btn-block">
              <button
                className="btn btn-medium btn-transparent"
                type="button"
                onClick={() => {
                  store.dispatch(addUserModal(false));
                  // history.push("/gym-panel/memberslist");
                }}
              >
                Cancel
              </button>
              <button
                value="Add Instructor"
                className="btn btn-medium"
                type="submit"
                disabled={props.disableSubmit}
              >
                {voiceReviewActionLabel(props.edit ? "Update Member" : "Add Member")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
